import { render, staticRenderFns } from "./newsChat.vue?vue&type=template&id=b7dd5c50&scoped=true&"
import script from "./newsChat.vue?vue&type=script&lang=js&"
export * from "./newsChat.vue?vue&type=script&lang=js&"
import style0 from "./newsChat.vue?vue&type=style&index=0&id=b7dd5c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dd5c50",
  null
  
)

export default component.exports